<template>
  <div v-if="isShareableChat">
    <v-btn
      class="share-btn"
      variant="text"
      rounded
      height="36"
      elevation="0"
      :ripple="false"
      @click="openDialog"
    >
      <v-icon
        size="20"
        class="me-2"
        color="primary"
      >
        mdi-share-variant
      </v-icon>
      <span class="d-none d-sm-inline">Share Chat</span>
    </v-btn>

    <ShareChatDialog v-model="dialog" />
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import ShareChatDialog from '@/interfaces/components/ShareChatDialog.vue';
  import { currentChat } from '@/interfaces/composables/useChatManager';

  const dialog = ref(false);

  const openDialog = () => {
    dialog.value = true;
  };

  const isShareableChat = computed(() => {
    return (
      currentChat.value &&
      currentChat.value.id !== 'new' &&
      !currentChat.value.id.startsWith('shared-')
    );
  });
</script>

<style scoped lang="sass">
  .share-btn
    pointer-events: auto
    margin-right: 0.5rem
    margin-top: 0.5rem
    text-transform: none
    font-size: 0.9rem
    font-weight: 500
    color: #333
    background-color: #f5f7fa
    border-radius: 8px
    padding: 0 12px
    transition: background-color 0.2s ease

    &:hover
      background-color: #e3f2fd
</style>
